import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'material-ui/Icon';

class Hover extends React.PureComponent {
  constructor(props) {
    super(props);
    const { top, left } = this.props;
    this.state = ({
        top: top,
        left: left
    });
  }

  componentDidMount() {
    const { top, left } = this.props;
    const width = document.getElementById('container').clientWidth;
    const height = document.getElementById('container').clientHeight;
    if( top + height >= window.innerHeight ) {
        this.setState({ top: top - height });
    }
    if( left + width >= window.innerWidth ) {
        this.setState({ left: left - width });
    }
  }

  render() {
    const { handleCloseDetailClick, node, top, left } = this.props;
    let description = node.description;
    description = description.replace(/(?:\r\n|\r|\n)/g, ' ');
    description = description.split('. ');
    return (
        <div className="hover-panel" style={{ top: this.state.top, left: this.state.left }} id="container">
            <div className="header">
                <div className="title">
                  <h3>{node.label}</h3>
                </div>
                <div className="photo">
                    <img src={ node.image } alt='photo' width='100' height='100' />
                </div>
                <Icon color="action" onClick={handleCloseDetailClick} className="close-icon">close</Icon>
            </div>
            <div className="clear" />
            <div className="description">
                {description[0]}
            </div>
        </div>
    );
  }
}

Hover.propTypes = {
  handleCloseDetailClick: PropTypes.func,
  left: PropTypes.number,
  node: PropTypes.object,
  top: PropTypes.number,
};

export default Hover;



// WEBPACK FOOTER //
// ./scripts/components/Hover.jsx